import { useQuery } from '@tanstack/react-query';

import { currentUserApi } from '../axios';

export function useUserMonthlyActionsQuery() {
  return useQuery({
    queryKey: ['userMonthlyActions'],
    queryFn: currentUserApi.getUserMonthlyActions,
  });
}
